<template>
    <div class="reply-auth">
        <div class="reply-auth-content">
            <div class="content-box" id="input" ref="input_area"></div>
            <div class="reply-footer">
                <div class="emoji-icon" id="toggle-icon">
                    <!-- <img
                        v-if="showIconList"
                        src="@/assets/emoji-icon-keyboard.png"
                    /> -->
                    <img src="@/assets/emoji-icon.png" />
                </div>
                <div>
                    <span class="des-color" style="margin-right: 8px"
                        ><span
                            :class="
                                inputCount < 200 ? 'des-color' : 'red-color'
                            "
                            >{{ getShowCount() }}</span
                        >/200</span
                    >
                    <div
                        :class="
                            getCanSubmit() ? 'send-btn disable' : 'send-btn'
                        "
                        @click="sendApi()"
                    >
                        发送
                    </div>
                </div>
            </div>
        </div>
        <div id="emoji-list-wrap" class="emoji-list-wrap"></div>
        <div class="bg" @click="closeReplyAuth(RHEmoji.getHtml())"></div>
        <Toast v-if="showToast" :text="toastText"></Toast>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Toast from '@/components/toast.vue'

import RHEmoji, { transCode2ImgFn } from '../../../components/rhEmoji/index'

import { request } from '@/api/request'
import { publishDetail, supportReview, support, unSupportReview, unSupport } from '@/api'

export default {
    name: "ReplyAuth",
    components: { Toast },
    props: {
        closeReplyAuth: {
            type: Function,
            default: () => { }
        },
        newsId: {
            type: String,
            default: () => ""
        },
        submitSuccess: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        ...mapState(['code', 'market', 'stockname', 'userInfo'])
    },
    data() {
        return {
            showToast: false,
            toastText: '',
            showIconList: false,
            RHEmoji: null,
            inputCount: 0
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.input_area.focus()
        })
        this.initEmoji()
    },
    methods: {
        _toast(toastText, time = 3000) {
            this.toastText = toastText
            this.showToast = true
            setTimeout(() => {
                this.showToast = false
            }, time)
        },
        getShowCount() {
            return this.inputCount < 200
                ? this.inputCount
                : -(this.inputCount - 200)
        },
        initEmoji() {
            const options = {
                mode: 'mobile',
                input: {
                    inputElement: 'input',
                    placeholder: '回复作者'
                },
                list: {
                    iconElement: 'toggle-icon',
                    wrapElement: 'emoji-list-wrap'
                },
            };
            this.RHEmoji = new RHEmoji(options)
            this.RHEmoji.toggleChange = this.toggleChange
            this.RHEmoji.onChange = this.handleOnChange
        },
        getCanSubmit() {
            if (this.inputCount > 0 && this.inputCount < 200) {
                return false
            }
            return true
        },
        toggleChange() {
            this.showIconList = !this.showIconList
        },
        handleOnChange() {
            this.inputCount = this.RHEmoji.count
        },
        isLogin() {
            if (!this.userInfo.token) {
                // this._toast('请登录')
                // setTimeout(() => {
                //     this.$router.push(`/login.html`)
                // }, 3000)
                this.$router.push(`/login.html?redirect=${this.$route.path}`)
                return false
            }
            return true
        },
        async sendApi() {
            const isLogin = this.isLogin()
            if (!isLogin) return
            const params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                newsId: this.newsId,
                parentId: '',
                content: this.RHEmoji.getContent(),
                column: 'stock.bar',
                platform: '9fztgw'
            }
            let res = await publishDetail(params)
            if (res.code === 1) {
                this.RHEmoji.clear()
                this.submitSuccess('auth')
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
.des-color
    color #999999

.red-color
    color #E94041

.reply-auth
    width 100%
    position fixed
    top 44px
    left 0
    align-content center

    .reply-auth-content
        background #fff
        padding 10px 16px

    *
        box-sizing border-box

    .footer-content
        background #fff

    .bg
        width 100%
        height 100vh
        background rgba(0, 0, 0, 0.5)
        z-index -1
        position fixed
        left 0
        bottom 0

    .content-box
        width 100%
        height 36px
        font-size 16px
        line-height 21px
        padding 0 14px
        padding-top 8px
        outline none
        margin-bottom 16px
        overflow-y scroll
        background #F5F5F5
        border-radius 2px

.reply-footer
    display flex
    justify-content space-between
    align-items center

    .emoji-icon
        >img
            width 26px
            height 26px

    .send-btn
        width 86px
        height 32px
        font-size 17px
        line-height 32px
        display inline-block
        text-align center
        background #F43737
        color #fff
        border-radius 2px

        &.disable
            background #DCDCDC
</style>
<style lang="stylus">
.reply-auth
    .rhemoji-triangle-icon-mobile
        left 21px !important
</style>